import { HttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';

export function setUserQualification() {
  return HttpClient.put(`/api/v2/account/qualified-investor`, {}, undefined);
}
